import { DateTime } from 'luxon';
import { HourReading, HourReadingSource } from './hour-reading';

export namespace HourReadingParsers {
  export class HourReadingJson {
    id!: string;
    unitId!: number;
    hour!: number;
    source!: HourReadingSource;
    trackedAt!: string;
  }

  export function toHourReadng(input: HourReadingJson): HourReading {
    return {
      ...input,
      trackedAt: DateTime.fromISO(input.trackedAt),
    };
  }
}
